<div class="col-md-12 no-padding animated fadeIn">
  <h3>Opções para para prestação de contas final:</h3>
  <hr>


  <button class="btn btn-app animated fadeInDown" pTooltip="Análise de contas" tooltipPosition="top" [routerLink]="['analise-contas/repasses']" routerLinkActive="btn-app-active">
    <i class="far fa-calendar"></i> Análise de contas
  </button>
  <!-- Painel da analise: contadores, historico com decurso e checklist (ADR-0010). -->
  <button class="btn btn-app animated fadeInDown" pTooltip="Contadores, histórico do fluxo e checklist"
    tooltipPosition="top" [routerLink]="['analise-contas/painel']" routerLinkActive="btn-app-active">
    <i class="fas fa-tasks"></i> Painel da análise
  </button>

  <button class="btn btn-app animated fadeInDown" pTooltip="Final" tooltipPosition="top">
    <i class="far fa-calendar"></i> Método de seleção
  </button>
  <button class="btn btn-app animated fadeInDown" pTooltip="Final" tooltipPosition="top">
    <i class="far fa-calendar"></i> Timeline
  </button>
  <button class="btn btn-app animated fadeInDown" pTooltip="Final" tooltipPosition="top">
    <i class="far fa-calendar"></i> Habilitação
  </button>
  <button class="btn btn-app animated fadeInDown" pTooltip="Final" tooltipPosition="top">
    <i class="far fa-calendar"></i> Bens
  </button>
  <button class="btn btn-app animated fadeInDown" pTooltip="Final" tooltipPosition="top">
    <i class="far fa-calendar"></i> Pendências
  </button>
  <button class="btn btn-app animated fadeInDown" pTooltip="Final" tooltipPosition="top">
    <i class="far fa-calendar"></i> Financeiro
  </button>
  <button class="btn btn-app animated fadeInDown" pTooltip="Final" tooltipPosition="top">
    <i class="far fa-calendar"></i> Termo de compromisso
  </button>
  <button class="btn btn-app animated fadeInDown" pTooltip="Final" tooltipPosition="top">
    <i class="far fa-calendar"></i> Exportar
  </button>

  

  <div class="col-md-12 no-padding">
    <hr>
  </div>

</div>

<div class="col-md-12">
  <router-outlet></router-outlet>
</div>